module.exports = __webpack_public_path__ + "img/gzh.fe51a803.jpg";